
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"26","viewBox":"0 0 23 26","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.342 10.8469C22.9838 11.8138 22.9838 14.1884 21.342 15.1553L3.76861 25.5042C2.10204 26.4857 -8.45417e-08 25.2841 0 23.35L9.04729e-07 2.65223C9.89271e-07 0.718146 2.10204 -0.483416 3.76861 0.498023L21.342 10.8469Z"}})])
          )
        }
      }
    